import React from 'react';
import { Link } from 'react-router-dom';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const ContactConfirmation = () => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, rgba(232, 232, 232, 0.92) 0%, rgba(248,250,252,0.95) 100%)',
            minHeight: 'auto',
            padding: '120px 60px 50px 60px',
            margin: '0',
            width: '100%'
        }}>
            <div style={{ width: '100%', maxWidth: 'none' }}>
                {/* Header Section */}
                <Row className="justify-content-center mb-5">
                    <Col lg={8} className="text-center">
                        <h1 style={{
                            fontSize: '3rem',
                            fontWeight: '300',
                            color: '#2d3748',
                            marginBottom: '0',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                        }}>
                            Message Sent!
                        </h1>
                    </Col>
                </Row>
                
                {/* Confirmation Card */}
                <Row className="justify-content-center">
                    <Col lg={8} md={10}>
                        <div style={{
                            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.9) 100%)',
                            borderRadius: '16px',
                            padding: '3rem',
                            boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                            border: 'none'
                        }}>
                            {/* Success Message */}
                            <div className="text-center mb-5">
                                <div style={{
                                    color: '#6c757d',
                                    fontSize: '0.95rem',
                                    fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                    lineHeight: '1.6'
                                }}>
                                    I'll get back to you within 24 hours.
                                </div>
                            </div>

                            {/* LinkedIn Connection Note */}
                            <div className="text-center mb-5">
                                <div style={{
                                    color: '#6c757d',
                                    fontSize: '0.95rem',
                                    fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                    lineHeight: '1.6'
                                }}>
                                    If we're not already connected, I'd love to connect on{' '}
                                    <a 
                                        href="https://linkedin.com/in/elliotkoss" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#6c757d',
                                            textDecoration: 'underline',
                                            transition: 'color 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = '#495057';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = '#6c757d';
                                        }}
                                    >
                                        LinkedIn
                                    </a>
                                    !
                                </div>
                            </div>

                            {/* Action Button */}
                            <div className="text-center">
                                <Link 
                                    to="/"
                                    style={{
                                        backgroundColor: '#667eea',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '14px 32px',
                                        fontSize: '1rem',
                                        fontWeight: '500',
                                        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                        textDecoration: 'none',
                                        display: 'inline-block',
                                        transition: 'all 0.2s ease',
                                        minWidth: '160px'
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.backgroundColor = '#5a67d8';
                                        e.target.style.transform = 'translateY(-1px)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.backgroundColor = '#667eea';
                                        e.target.style.transform = 'translateY(0)';
                                    }}
                                >
                                    Return to Home
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ContactConfirmation;

